<app-base-modal
  variant="confirmation"
  [title]="title"
  [size]="size"
  [width]="width"
  [height]="height"
  (closed)="cancel.emit()"
>
  <ng-content></ng-content>

  <div actions class="modal-action-row">
    <button *ngIf="showCancel" type="button" class="action-pill cancel" (click)="cancel.emit()">
      {{ cancelText }}
    </button>
    <button type="button" class="action-pill confirm" (click)="confirm.emit()">
      {{ confirmText }}
    </button>
  </div>
</app-base-modal>
